// This file recognizes the following GET parameters.
const gGetParams = {
	/** @type {string|undefined} */
	folder: undefined,

	/** @type {"windows"|"linux"|"mac"|undefined} */
	platform: undefined,
};

// Process GET parameters.
(() => {
	const url = new URL(window.location.href);

	const folderParam = url.searchParams.get("folder");
	const platformParam = url.searchParams.get("platform");

	if (folderParam) {
		gGetParams.folder = folderParam;
	}

	switch(platformParam) {
		case "windows":
		case "linux":
		case "mac":
			gGetParams.platform = platformParam;
			break;

		default:
			break;
	}

	Object.freeze(gGetParams);
})();

(() => {
	/** @type {HTMLAnchorElement[]} */
	const linkIcons = Array.from(document.querySelectorAll("section[id] a.js-link"));

	for (const linkIcon of linkIcons) {
		const id = linkIcon.closest("section[id]").id;
		const url = `${window.location.origin}${window.location.pathname}#${id}`;
		linkIcon.href = url;
	}
})();

// Output folder input, platform, and platform-specific locations.
(() => {
	const Platforms = {
		WINDOWS: "windows",
		LINUX: "linux",
	};

	const PlatformSeparator = {
		[Platforms.WINDOWS]: "\\",
		[Platforms.LINUX]: "/",
	};

	let rawOutputFolder = "";
	let platformSeparator = PlatformSeparator[Platforms.WINDOWS];


	const updateLocations = () => {
		const rootFolder = (() => {
			if (rawOutputFolder === "") {
				return "{OUTPUT_FOLDER}";
			} else if (/obs-bible-plugin(?:\/|\\)?$/.test(rawOutputFolder)) {
				const index = rawOutputFolder.search(/obs-bible-plugin(?:\/|\\)?$/);
				return rawOutputFolder.slice(0, index - 1);
			} else if (rawOutputFolder.endsWith(platformSeparator)) {
				return rawOutputFolder.slice(0, rawOutputFolder.length - 1);
			} else {
				return rawOutputFolder;
			}
		})();

		const joinPath = (...segments) => {
			return segments.join(platformSeparator);
		};


		const browserIndexFile = joinPath(rootFolder, "obs-bible-plugin", "obs-bible-plugin-browser", "index.html");
		document.querySelectorAll("a.js-browser-index-file").forEach(node => {
			const protocol = "file://";
			const fullUrl = protocol + browserIndexFile;

			node.innerHTML = fullUrl;
			node.href = fullUrl;
			node.title = `Copy ${fullUrl}`

			node.addEventListener("click", (ev) => {
				ev.preventDefault();
				navigator.clipboard.writeText(fullUrl)
					.then(() => {
						node.innerHTML = "(Copied)";
						window.setTimeout(() => {
							node.innerHTML = fullUrl;
						}, 1500);
					});
			});
		});

		const dockIndexFile = joinPath(rootFolder, "obs-bible-plugin", "obs-bible-plugin-dock", "index.html");
		document.querySelectorAll("a.js-dock-index-file").forEach(node => {
			const protocol = "file://";
			const fullUrl = protocol + dockIndexFile;

			node.innerHTML = fullUrl;
			node.href = fullUrl;
			node.title = `Copy ${fullUrl}`;

			node.addEventListener("click", (ev) => {
				ev.preventDefault();
				navigator.clipboard.writeText(fullUrl)
					.then(() => {
						node.innerHTML = "(Copied)";
						window.setTimeout(() => {
							node.innerHTML = fullUrl;
						}, 1500);
					});
			});
		});
	};


	/** @type {HTMLInputElement} */
	const outputFolderInput = document.getElementById("output-folder-input");

	/** @type {HTMLInputElement} */
	const windowsRadio = document.getElementById("win-radio");

	/** @type {HTMLInputElement} */
	const linuxRadio = document.getElementById("linux-radio");


	if (gGetParams.folder && gGetParams.platform) {
		rawOutputFolder = gGetParams.folder;

		switch (gGetParams.platform) {
			case "windows":
				platformSeparator = PlatformSeparator[Platforms.WINDOWS];
				windowsRadio.checked = true;
				outputFolderInput.value = rawOutputFolder;
				break;

			case "linux":
			case "mac":
				platformSeparator = PlatformSeparator[Platforms.LINUX];
				linuxRadio.checked = true;
				outputFolderInput.value = rawOutputFolder;
				break;
		}
	}


	outputFolderInput.addEventListener("input", (ev) => {
		/** @type {string} */
		const value = ev.target.value;

		rawOutputFolder = value;
		updateLocations();
	});

	const updatePlatform = () => {
		if (windowsRadio.checked) {
			platform = Platforms.WINDOWS;
			platformSeparator = PlatformSeparator[Platforms.WINDOWS];
		} else if (linuxRadio.checked) {
			platform = Platforms.LINUX;
			platformSeparator = PlatformSeparator[Platforms.LINUX];
		}

		updateLocations();
	}

	updatePlatform();
	windowsRadio.addEventListener("input", ev => { updatePlatform(); });
	linuxRadio.addEventListener("input", ev => { updatePlatform(); });
})();

// Swiper: Browser Source and Dock Setup
(() => {
	const els = [
		".browser-slideshow",
		".dock-slideshow",
	];

	for (const el of els) {
		new Swiper(`${el}`, {
			// Optional parameters
			direction: "horizontal",

			// Navigation arrows
			navigation: {
				nextEl: `${el} .swiper-button-next`,
				prevEl: `${el} .swiper-button-prev`,
			},

			pagination: {
				el: `${el} .swiper-pagination`,
				clickable: true,
			},
		});
	}
})();